import { Add } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, CircularProgress, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setSearchValue, setSelectedItem } from 'app/actions/driver';
import { IconButton, Image, InputSearch, Scrollbar } from 'app/components';
import { DriverDialog, DriverForm, DriverList } from 'app/pages/Driver';
import { useAsyncAction } from 'app/services';
import { driverDelete, driverLoad, driverUpdate } from 'app/store/driver';
import { autocolunItemsLoad, divisionItemsLoad } from 'app/store/transport';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Driver = () => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { items, selectedItem, searchValue } = useSelector((state) => state.driver);
    const [dialogOpen, setDialogOpen] = useState(false);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(driverLoad);
    const { asyncAction: fetchAutocolunItems, isLoading: isAutocolunItemsLoading } = useAsyncAction(autocolunItemsLoad);
    const { asyncAction: fetchDivisionItems, isLoading: isDivisionItemsLoading } = useAsyncAction(divisionItemsLoad);
    const isLoading = isFetchLoading || isAutocolunItemsLoading || isDivisionItemsLoading;
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, } = useAsyncAction(driverUpdate, [selectedItem]);
    const { asyncAction: deleteSubmit, isLoading: isDeleteLoading, isSuccessful: isDeleteSuccessful, isError: isDeleteError, } = useAsyncAction(driverDelete, [selectedItem]);
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        if (selectedItem) {
            updateSubmit(selectedItem.id, params);
        }
    };
    const handleDeleteClick = () => {
        if (selectedItem) {
            deleteSubmit(selectedItem.id);
        }
    };
    const handleDriverSearchChange = (value) => dispatch(setSearchValue(value));
    useEffect(() => {
        fetchData();
        fetchDivisionItems();
        fetchAutocolunItems();
        return () => {
            dispatch(setSelectedItem(null));
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '500px',
                height: '100%',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
            }) },
            !isLoading && items.length ? (React.createElement(React.Fragment, null,
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(InputSearch, { placeholder: '\u0424\u0418\u041E \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F', value: searchValue, onChange: handleDriverSearchChange }),
                    React.createElement(IconButton, { onClick: handleDialogOpen, endIcon: React.createElement(Add, null) }),
                    React.createElement(DriverDialog, { open: dialogOpen, onClose: handleDialogClose })),
                React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                        flex: '1 1 auto',
                        overflow: 'hidden',
                    } },
                    React.createElement(DriverList, null)))) : (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430"))),
            isLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(CircularProgress, { size: 24 })))),
        React.createElement(Stack, { direction: 'column', sx: {
                height: '100%',
                flex: '1 1 auto',
            } },
            selectedItem && (React.createElement(Scrollbar, null,
                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                        maxWidth: '540px',
                        margin: 'auto',
                        width: '100%',
                        padding: theme.spacing(4, 2),
                    }) },
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            marginBottom: theme.spacing(3),
                            '.MuiAvatar-root': {
                                width: '56px',
                                height: '56px',
                                bgcolor: theme.palette.primary.main,
                            },
                            '.MuiTypography-root:first-of-type': {
                                marginTop: theme.spacing(1),
                            },
                        }) },
                        React.createElement(Avatar, null,
                            React.createElement(Image, { name: 'avatar-driver.png', alt: 'avatar-driver' })),
                        React.createElement(Typography, { variant: 'body1' }, selectedItem.name)),
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            width: '100%',
                            position: 'relative',
                            padding: theme.spacing(2),
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            form: {
                                width: '100%',
                            },
                        }) },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                paddingBottom: theme.spacing(1),
                                '.MuiTypography-h6': {
                                    fontSize: '1rem',
                                },
                                '.MuiTypography-caption': {
                                    color: theme.palette.text.secondary,
                                },
                            }) },
                            React.createElement(Typography, { variant: 'h6' }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                            React.createElement(Typography, { variant: 'caption' }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F \u0438 \u0435\u0433\u043E \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435")),
                        React.createElement(DriverForm, { ref: formRef, defaultValues: selectedItem, onSubmit: handleFormSubmit }),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(2),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            !isUpdateLoading && isUpdateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                            !isUpdateLoading && isUpdateSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                paddingTop: theme.spacing(3),
                            }) },
                            React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: handleFormClick, disableElevation: true }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"))),
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            width: '100%',
                            position: 'relative',
                            marginTop: theme.spacing(3),
                            padding: theme.spacing(2),
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            '.MuiAlert-root': {
                                marginTop: theme.spacing(0),
                                marginBottom: theme.spacing(3),
                            },
                        }) },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                paddingBottom: theme.spacing(3),
                                '.MuiTypography-h6': {
                                    fontSize: '1rem',
                                },
                                '.MuiTypography-caption': {
                                    color: theme.palette.text.secondary,
                                },
                            }) },
                            React.createElement(Typography, { variant: 'h6' }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F"),
                            React.createElement(Typography, { variant: 'caption' }, "\u041C\u043E\u0436\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F, \u043D\u043E \u044D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0431\u0443\u0434\u044C\u0442\u0435 \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(1),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            isDeleteError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                            isDeleteSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0412\u043E\u0434\u0438\u0442\u0435\u043B\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D.")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                paddingTop: theme.spacing(0),
                            }) },
                            React.createElement(LoadingButton, { color: 'error', variant: 'contained', onClick: handleDeleteClick, loading: isDeleteLoading, disableElevation: true }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F")))))),
            !selectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    height: '100%',
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                        borderRadius: '20px',
                        marginTop: '24px',
                        padding: theme.spacing(0.5, 2),
                        bgcolor: alpha(theme.palette.grey.main, 0.12),
                    },
                }) },
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"))))));
};
export default Driver;
